import Model, { attr } from '@ember-data/model';

export default class BaseItemModel extends Model {
  @attr('string', { defaultValue: '' }) declare text: string;
  @attr declare text_delta: unknown;
  @attr('boolean', { defaultValue: false }) declare completed: boolean;
  @attr('boolean', { defaultValue: false }) declare archived: boolean;
  @attr('number') declare age_in_days: number;
  @attr('number') declare position: number;
  @attr declare tags: unknown;
  // @attr mentions;
  @attr('string') declare updated_at: string;
  // New items need a sortable date. The runtime calls any defaultValue function.
  // @ts-expect-error: attr's types only allow functions that return objects
  @attr('string', {
    defaultValue() {
      return new Date().toISOString();
    },
  })
  declare created_at: string;
}
